import categoryRoutesReducer from './category-routesReducer';

export * from './category-routesActions';
export default categoryRoutesReducer;
